import { useModal } from '@ebay/nice-modal-react';
import { Box, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Button, Typography, SizingMultiplier } from '@ocx/ui';
import { ModalDrawer } from '@ocx/ui-modals';
import { OfferDetailsMedia, SurgeonWarning } from '@ocx/ui-offers';
import { buttonTextMessages } from '@ocx-app/modules/localization/button-text.messages';

import { ExternalBannerDetailsPopupProps } from './external-banner-details-popup.types';
import { messages } from './external-banner-details-popup.messages';

export const ExternalBannerDetailsPopupController = (props: ExternalBannerDetailsPopupProps) => {
  const { visible, hide, remove } = useModal();
  const {
    banner: {
      content: { title, titleMiddle, title2, imageUrl, surgeonGeneralWarning },
    },
    hasAltriaOffersNearby,
  } = props;

  return (
    <ModalDrawer open={visible} onClose={hide} onExited={remove}>
      {surgeonGeneralWarning && (
        <Box m={SizingMultiplier.md}>
          <SurgeonWarning message={surgeonGeneralWarning} size="large" square />
        </Box>
      )}
      {imageUrl && <OfferDetailsMedia variant="big-image" src={imageUrl} alt={title} />}
      <Stack spacing={SizingMultiplier.md} pt={SizingMultiplier.lg} px={SizingMultiplier.lg} pb={SizingMultiplier.xl}>
        <Typography variant="h6">
          {title} {titleMiddle} {title2}
        </Typography>

        {hasAltriaOffersNearby === 'not-available' && (
          <Box
            sx={(theme) => ({
              px: SizingMultiplier.md,
              py: SizingMultiplier.md,
              backgroundColor: theme.palette.action.selected,
              borderRadius: 1.5,
            })}>
            <Typography variant="body2" color="text.primary">
              <FormattedMessage {...messages['external-banner-details-popup:unavailable-nearby-stores']} />
            </Typography>
          </Box>
        )}
        <Button variant="text" fullWidth onClick={hide}>
          <FormattedMessage {...buttonTextMessages['button-text:close']} />
        </Button>
      </Stack>
    </ModalDrawer>
  );
};
